import { get } from "lodash";
export const statusMap = {
  ok: 1, // 可购买
  quota: 2, // 已售罄 已报满（无库存）
  sale_wait: 3, // 待开售
  sale_stop: 4, // 已停售
  registered: 5, // 已购买
  exam_not: 6, // 未考试诊断
  exam_unqualified: 7, // 诊断未通过
  exam_no_qualification: 8, // 诊断未通过，暂无报名资格
};

export const getUrlParams = (url = window.location.href) => {
  const vars = {};
  url.replace(/[?&]+([^=&]+)=([^&#]*)/gi, function (m, key, value) {
    vars[key] = value;
  });
  return vars;
};
export const getUrlSelect = () => {
  const queryObj = getUrlParams();
  return queryObj?.select === "1" || queryObj?.select === "2"
    ? queryObj.select
    : false;
};
export const $$ = (obj = {}, path, defaultVal = {}) => {
  return get(obj, path, defaultVal);
};
export const disabledStatus = [
  statusMap.quota,
  statusMap.sale_wait,
  statusMap.sale_stop,
  statusMap.registered,
  statusMap.exam_unqualified,
  statusMap.exam_no_qualification,
];
export const availableStatus = [statusMap.ok, statusMap.exam_not];

export const setSelectType = (item) => {
  // status课包课程状态 1：可购买，2：已售罄 已报满（无库存），3：待开售，4：已停售，5：已购买，6：未考试诊断，7：诊断未通过，8：诊断未通过，暂无报名资格
  // 根据课包课程状态 处理课卡可选状态 selectType 1：可选，2：已选，3：禁选
  // 若状态不可买，置灰
  if (disabledStatus.includes(item.status?.id)) {
    item.selectType = 3;
  } else if (availableStatus.includes(item.status?.id)) {
    // 若状态可买，那么设置为未勾选状态
    item.selectType = 1;
    // 若页面没有勾选框，或者当前数据设置为默认勾选，那么设置为已勾选状态
    if (!getUrlSelect() || item.checked) {
      item.selectType = 2;
    }
  }
};

// 获取埋点公共数据
export const getLogParams = (courseInfo = {}) => {
  const course = (courseInfo?.product_list || []).find(
    (item) => item.type === 100
  );
  const params = {
    subject_name: course?.extra_info?.subject_name || "", // 学科
    grade_name: course?.extra_info?.grade_names?.join(",") || "", // 年级
    commodity_type: courseInfo.type, // 商品类型
    commodity_name: courseInfo.name, // 商品名称
    commodity_id: courseInfo.id, // 商品id
    promotion_id: courseInfo.promotion_id, // 促销id
  };
  if (courseInfo.isIncrease) {
    params.related_main_product_id = courseInfo.parent_product_id;
    params.default_check_states = courseInfo.checked ? 1 : 2;
    params.respos_card_type = courseInfo.positionIndex + 1;
  }
  console.log("getLogParams", courseInfo, params);
  return params;
};

// 类目属性  https://yach-doc-shimo.zhiyinlou.com/sheets/erAdPyGWp7tQKyAG/MODOC 《类目属性值》
const attribute = {
  test: {
    sever: 155, // 服务保障
    instalment: 154, // 分期付
    isLimit: 157, // 是否限购
    purchaseLimit: 158, // 限购数量
    InterestFree: 159, // 免息政策
    specs: 74, // 规格
    category_id: {
      xuexiji: 410, // 学习机
    },
  },
  online: {
    sever: 70,
    instalment: 65,
    isLimit: 67,
    purchaseLimit: 68,
    InterestFree: 66,
    specs: 71,
    category_id: {
      xuexiji: 96, // 学习机
    },
  },
}[
  process.env.VUE_APP_SECRET && process.env.VUE_APP_SECRET !== "test"
    ? "online"
    : "test"
];

// 实物商品的一些数据需要根据后端返回的数据拼接好
export const transfromGoodsInfo = (list, type) => {
  if (!list) return [];
  return list.map((item, positionIndex) => {
    // 107 实物商品
    if (type === "increase") {
      item.positionIndex = positionIndex;
      item.isIncrease = true;
    }
    if (!item || item.type !== 107) {
      return item;
    }
    const attrInfo = item.attr_info || [];
    // 服务描述
    const serviceItem = attrInfo.find(
      (attr) => attr.attr_id === attribute.sever
    );
    const serviceValueInfo = serviceItem?.value_info || [];
    const serviceDesc = serviceValueInfo
      .slice(0, 3)
      .map((v) => v.value_name)
      .join("·");

    // 是否支持分期付款
    const instalmentItem = attrInfo.find(
      (attr) => attr.attr_id === attribute.instalment
    );
    const isInstalment =
      (instalmentItem?.value_info || [])[0]?.value_name === "是";

    // 是否限购
    const limitItem = attrInfo.find(
      (attr) => attr.attr_id === attribute.isLimit
    );
    const isLimit = (limitItem?.value_info || [])[0]?.value_name === "是";

    // 限购数量
    const purchaseLimitItem = attrInfo.find(
      (attr) => attr.attr_id === attribute.purchaseLimit
    );
    const purchaseLimit = (purchaseLimitItem?.value_info || [])[0]?.value_name;

    // 是否免息
    const interestFreeItem = attrInfo.find(
      (attr) => attr.attr_id === attribute.InterestFree
    );
    const interestFree = (interestFreeItem?.value_info || [])[0]?.value_name;

    // 商品标签
    const goodLabels = [];
    if (isLimit && purchaseLimit) {
      goodLabels.push(
        `限购${purchaseLimit}${
          item.category_id === attribute.category_id.xuexiji
            ? purchaseLimitItem?.unit
            : "个"
        }`
      );
    }
    if (isInstalment && interestFree) {
      goodLabels.push(interestFree);
    }

    // 商品规格
    const specInfo = item.spec_info || [];
    const specItem = specInfo.find((spec) => spec.spec_id === attribute.specs);
    const specs = specItem?.spec_value_name;

    return {
      ...item,
      service_desc: serviceDesc,
      isInstalment,
      goodLabels,
      specs,
    };
  });
};
